import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'lib-not-found',
  template: `
    <div>
      <header>
        <h1 class="mat-display-1">404 Not Found</h1>
        <p class="mat-subheading-2">You either wound up here by mistake or the link is broken!</p>
        <mat-divider></mat-divider>
      </header>
      <main>
        <h3>For assistance contact the email below</h3>
        <mat-chip-set>
          <mat-chip selected color="primary" cdkCopyToClipboard="my_email@somewhere.com"
            (cdkCopyToClipboardCopied)="snackbar.open('Email Copied', null, { duration: 3000 })">help&#64;linescale.com<mat-icon>content_copy</mat-icon></mat-chip>
        </mat-chip-set>
      </main>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100vw;
      height: 100vh;
    }
  
    div {
        max-width: 70%;
        padding-top: 25%;
        margin: auto;
    }

    main, header {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }

    mat-divider {
      width: 100%;
    }

    mat-icon {
      margin-left: 8px;
    }
  `]
})
export class NotFoundComponent implements OnInit {

  constructor(public snackbar: MatSnackBar) { }

  ngOnInit() {
  }

}
